import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungListStatus: 'idle',
    loadMeldungListError: undefined as any,
    loadMeldungListLastArgs: undefined as any,
    loadMeldungStatus: 'idle',
    loadMeldungError: undefined as any,
    saveMeldungStatus: 'idle',
    saveMeldungError: undefined as any,
    deleteMeldungStatus: 'idle',
    deleteMeldungError: undefined as any,
    loadBtKreisTypGebaeudeStatus: 'idle',
    loadBtKreisTypGebaeudeError: undefined as any,
    loadBtKreisTypGebaeudeTeilStatus: 'idle',
    loadBtKreisTypGebaeudeTeilError: undefined as any,
    loadBtKreisTypGeschossStatus: 'idle',
    loadBtKreisTypGeschossError: undefined as any,
    loadBtKreisTypGebaeudeObjStatus: 'idle',
    loadBtKreisTypGebaeudeObjError: undefined as any,
    loadBtKreisTypGebaeudeTeilObjStatus: 'idle',
    loadBtKreisTypGebaeudeTeilObjError: undefined as any,
    loadBtKreisTypGeschossObjStatus: 'idle',
    loadBtKreisTypGeschossObjError: undefined as any,

    meldungList: [] as any[],
    btKreisTypGebaeude: undefined as any,
    btKreisTypGebaeudeObj: undefined as any,
    btKreisTypGebaeudeTeil: undefined as any,
    btKreisTypGebaeudeTeilObj: undefined as any,
    btKreisTypGeschoss: undefined as any,
    btKreisTypGeschossObj: undefined as any,
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungList = createAsyncThunk('auftragMeldungSlice/loadMeldungList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragMeldungSlice.loadMeldungListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldung/?action=eql&HDR_ID=${parentModel.MELDUNGID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungListStatus } = getState().auftragMeldungSlice
        return loadMeldungListStatus !== 'pending'
    }
})

export const loadMeldung = createAsyncThunk('auftragMeldungSlice/loadMeldung', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldung/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungStatus } = getState().auftragMeldungSlice
        return loadMeldungStatus !== 'pending'
    }
})

export const saveMeldung = createAsyncThunk('auftragMeldungSlice/saveMeldung', async ({ meldung }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldung?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurismeldung/${ meldung?.HDR_ID }/`,
            prepareData(meldung),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurismeldung/`,
            prepareData(meldung),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungStatus } = getState().auftragMeldungSlice
        return saveMeldungStatus !== 'pending'
    }
})

export const deleteMeldung = createAsyncThunk('auftragMeldungSlice/deleteMeldung', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurismeldung/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungStatus } = getState().auftragMeldungSlice
        return deleteMeldungStatus !== 'pending'
    }
})

export const loadBtKreisTypGebaeude = createAsyncThunk('auftragMeldungSlice/loadBtKreisTypGebaeude', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreistyp/?action=eql&DefinedType=3`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGebaeudeStatus } = getState().auftragMeldungSlice
        return loadBtKreisTypGebaeudeStatus !== 'pending'
    }
})

export const loadBtKreisTypGebaeudeTeil = createAsyncThunk('auftragMeldungSlice/loadBtKreisTypGebaeudeTeil', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreistyp/?action=eql&DefinedType=1`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGebaeudeTeilStatus } = getState().auftragMeldungSlice
        return loadBtKreisTypGebaeudeTeilStatus !== 'pending'
    }
})

export const loadBtKreisTypGeschoss = createAsyncThunk('auftragMeldungSlice/loadBtKreisTypGeschoss', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreistyp/?action=eql&DefinedType=2`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGeschossStatus } = getState().auftragMeldungSlice
        return loadBtKreisTypGeschossStatus !== 'pending'
    }
})

export const loadBtKreisTypGebaeudeObj = createAsyncThunk('auftragMeldungSlice/loadBtKreisTypGebaeudeObj', async ({ meldung, btKreisTypGebaeude }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkrtypobjrel/?action=eql&ObjNr=${meldung.OBJNR}&BTKREISTYPID=${btKreisTypGebaeude.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGebaeudeObjStatus } = getState().auftragMeldungSlice
        return loadBtKreisTypGebaeudeObjStatus !== 'pending'
    }
})

export const loadBtKreisTypGebaeudeTeilObj = createAsyncThunk('auftragMeldungSlice/loadBtKreisTypGebaeudeTeilObj', async ({ meldung, btKreisTypGebaeudeTeil }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkrtypobjrel/?action=eql&ObjNr=${meldung.OBJNR}&BTKREISTYPID=${btKreisTypGebaeudeTeil.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGebaeudeTeilObjStatus } = getState().auftragMeldungSlice
        return loadBtKreisTypGebaeudeTeilObjStatus !== 'pending'
    }
})

export const loadBtKreisTypGeschossObj = createAsyncThunk('auftragMeldungSlice/loadBtKreisTypGeschossObj', async ({ meldung, btKreisTypGeschoss }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkrtypobjrel/?action=eql&ObjNr=${meldung.OBJNR}&BTKREISTYPID=${btKreisTypGeschoss.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGeschossObjStatus } = getState().auftragMeldungSlice
        return loadBtKreisTypGeschossObjStatus !== 'pending'
    }
})

const MeldungSlice = createSlice({
    name: 'auftragMeldungSlice',
    initialState,
    reducers: {
        resetloadMeldungListError: (state) => {
            state.loadMeldungListError = undefined
        },
        resetloadMeldung: (state) => {
            state.formItem = undefined
            state.loadMeldungError = undefined
        },
        resetloadMeldungError: (state) => {
            state.loadMeldungError = undefined
        },
        resetsaveMeldung: (state) => {
            state.formItem = undefined
            state.saveMeldungError = undefined
        },
        resetsaveMeldungError: (state) => {
            state.saveMeldungError = undefined
        },
        resetdeleteMeldungError: (state) => {
            state.deleteMeldungError = undefined
        },
        resetloadBtKreisTypGebaeude: (state) => {
            state.btKreisTypGebaeude = undefined
            state.loadBtKreisTypGebaeudeError = undefined
        },
        resetloadBtKreisTypGebaeudeError: (state) => {
            state.loadBtKreisTypGebaeudeError = undefined
        },
        resetloadBtKreisTypGebaeudeTeil: (state) => {
            state.btKreisTypGebaeudeTeil = undefined
            state.loadBtKreisTypGebaeudeTeilError = undefined
        },
        resetloadBtKreisTypGebaeudeTeilError: (state) => {
            state.loadBtKreisTypGebaeudeTeilError = undefined
        },
        resetloadBtKreisTypGeschoss: (state) => {
            state.btKreisTypGeschoss = undefined
            state.loadBtKreisTypGeschossError = undefined
        },
        resetloadBtKreisTypGeschossError: (state) => {
            state.loadBtKreisTypGeschossError = undefined
        },
        resetloadBtKreisTypGebaeudeObj: (state) => {
            state.btKreisTypGebaeudeObj = undefined
            state.loadBtKreisTypGebaeudeObjError = undefined
        },
        resetloadBtKreisTypGebaeudeObjError: (state) => {
            state.loadBtKreisTypGebaeudeObjError = undefined
        },
        resetloadBtKreisTypGebaeudeTeilObj: (state) => {
            state.btKreisTypGebaeudeTeilObj = undefined
            state.loadBtKreisTypGebaeudeTeilObjError = undefined
        },
        resetloadBtKreisTypGebaeudeTeilObjError: (state) => {
            state.loadBtKreisTypGebaeudeTeilObjError = undefined
        },
        resetloadBtKreisTypGeschossObj: (state) => {
            state.btKreisTypGeschossObj = undefined
            state.loadBtKreisTypGeschossObjError = undefined
        },
        resetloadBtKreisTypGeschossObjError: (state) => {
            state.loadBtKreisTypGeschossObjError = undefined
        },
        removeFromMeldungListById: (state, action) => {
            state.meldungList = state.meldungList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungListByIds: (state, action) => {
            state.meldungList = state.meldungList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungListStatus = 'preloaded'
            state.loadMeldungListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungList = []
            state.loadMeldungListStatus = 'idle'
            state.loadMeldungListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungList.pending, (state) => {
            state.loadMeldungListStatus = 'pending'
            state.loadMeldungListError = undefined
        })
        builder.addCase(loadMeldungList.fulfilled, (state, action) => {
            state.loadMeldungListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungListLastArgs = action.payload.args

            {
                state.meldungList = action.payload.data

            }
        })
        builder.addCase(loadMeldungList.rejected, (state, action) => {
            state.loadMeldungListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungListError = action.error.message
            } else {
                state.loadMeldungListError = action.payload
            }
        })

        builder.addCase(loadMeldung.pending, (state) => {
            state.loadMeldungStatus = 'pending'
            state.loadMeldungError = undefined
        })
        builder.addCase(loadMeldung.fulfilled, (state, action) => {
            state.loadMeldungStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungList.push(newItem) }
                else { state.meldungList[i] = { ...state.meldungList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldung.rejected, (state, action) => {
            state.loadMeldungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungError = action.error.message
            } else {
                state.loadMeldungError = action.payload
            }
        })

        builder.addCase(saveMeldung.pending, (state) => {
            state.saveMeldungStatus = 'pending'
            state.saveMeldungError = undefined
        })
        builder.addCase(saveMeldung.fulfilled, (state, action) => {
            state.saveMeldungStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungList.push(newItem) }
                else { state.meldungList[i] = { ...state.meldungList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldung.rejected, (state, action) => {
            state.saveMeldungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungError = action.error.message
            } else {
                state.saveMeldungError = action.payload
            }
        })

        builder.addCase(deleteMeldung.pending, (state) => {
            state.deleteMeldungStatus = 'pending'
            state.deleteMeldungError = undefined
        })
        builder.addCase(deleteMeldung.fulfilled, (state, action) => {
            state.deleteMeldungStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungList = state.meldungList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungList = state.meldungList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldung.rejected, (state, action) => {
            state.deleteMeldungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungError = action.error.message
            } else {
                state.deleteMeldungError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGebaeude.pending, (state) => {
            state.loadBtKreisTypGebaeudeStatus = 'pending'
            state.loadBtKreisTypGebaeudeError = undefined
        })
        builder.addCase(loadBtKreisTypGebaeude.fulfilled, (state, action) => {
            state.loadBtKreisTypGebaeudeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGebaeude = newItem
            }
        })
        builder.addCase(loadBtKreisTypGebaeude.rejected, (state, action) => {
            state.loadBtKreisTypGebaeudeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGebaeudeError = action.error.message
            } else {
                state.loadBtKreisTypGebaeudeError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGebaeudeTeil.pending, (state) => {
            state.loadBtKreisTypGebaeudeTeilStatus = 'pending'
            state.loadBtKreisTypGebaeudeTeilError = undefined
        })
        builder.addCase(loadBtKreisTypGebaeudeTeil.fulfilled, (state, action) => {
            state.loadBtKreisTypGebaeudeTeilStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGebaeudeTeil = newItem
            }
        })
        builder.addCase(loadBtKreisTypGebaeudeTeil.rejected, (state, action) => {
            state.loadBtKreisTypGebaeudeTeilStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGebaeudeTeilError = action.error.message
            } else {
                state.loadBtKreisTypGebaeudeTeilError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGeschoss.pending, (state) => {
            state.loadBtKreisTypGeschossStatus = 'pending'
            state.loadBtKreisTypGeschossError = undefined
        })
        builder.addCase(loadBtKreisTypGeschoss.fulfilled, (state, action) => {
            state.loadBtKreisTypGeschossStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGeschoss = newItem
            }
        })
        builder.addCase(loadBtKreisTypGeschoss.rejected, (state, action) => {
            state.loadBtKreisTypGeschossStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGeschossError = action.error.message
            } else {
                state.loadBtKreisTypGeschossError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGebaeudeObj.pending, (state) => {
            state.loadBtKreisTypGebaeudeObjStatus = 'pending'
            state.loadBtKreisTypGebaeudeObjError = undefined
        })
        builder.addCase(loadBtKreisTypGebaeudeObj.fulfilled, (state, action) => {
            state.loadBtKreisTypGebaeudeObjStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGebaeudeObj = newItem
            }
        })
        builder.addCase(loadBtKreisTypGebaeudeObj.rejected, (state, action) => {
            state.loadBtKreisTypGebaeudeObjStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGebaeudeObjError = action.error.message
            } else {
                state.loadBtKreisTypGebaeudeObjError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGebaeudeTeilObj.pending, (state) => {
            state.loadBtKreisTypGebaeudeTeilObjStatus = 'pending'
            state.loadBtKreisTypGebaeudeTeilObjError = undefined
        })
        builder.addCase(loadBtKreisTypGebaeudeTeilObj.fulfilled, (state, action) => {
            state.loadBtKreisTypGebaeudeTeilObjStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGebaeudeTeilObj = newItem
            }
        })
        builder.addCase(loadBtKreisTypGebaeudeTeilObj.rejected, (state, action) => {
            state.loadBtKreisTypGebaeudeTeilObjStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGebaeudeTeilObjError = action.error.message
            } else {
                state.loadBtKreisTypGebaeudeTeilObjError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGeschossObj.pending, (state) => {
            state.loadBtKreisTypGeschossObjStatus = 'pending'
            state.loadBtKreisTypGeschossObjError = undefined
        })
        builder.addCase(loadBtKreisTypGeschossObj.fulfilled, (state, action) => {
            state.loadBtKreisTypGeschossObjStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGeschossObj = newItem
            }
        })
        builder.addCase(loadBtKreisTypGeschossObj.rejected, (state, action) => {
            state.loadBtKreisTypGeschossObjStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGeschossObjError = action.error.message
            } else {
                state.loadBtKreisTypGeschossObjError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungListError,
    resetloadMeldung,
    resetloadMeldungError,
    resetsaveMeldung,
    resetsaveMeldungError,
    resetdeleteMeldungError,
    resetloadBtKreisTypGebaeude,
    resetloadBtKreisTypGebaeudeError,
    resetloadBtKreisTypGebaeudeTeil,
    resetloadBtKreisTypGebaeudeTeilError,
    resetloadBtKreisTypGeschoss,
    resetloadBtKreisTypGeschossError,
    resetloadBtKreisTypGebaeudeObj,
    resetloadBtKreisTypGebaeudeObjError,
    resetloadBtKreisTypGebaeudeTeilObj,
    resetloadBtKreisTypGebaeudeTeilObjError,
    resetloadBtKreisTypGeschossObj,
    resetloadBtKreisTypGeschossObjError,
    removeFromMeldungListById,
    removeFromMeldungListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungSlice.actions
export default MeldungSlice.reducer
